import { render, staticRenderFns } from "./item-badge.vue?vue&type=template&id=23fa77e4&scoped=true"
import script from "./item-badge.vue?vue&type=script&lang=js"
export * from "./item-badge.vue?vue&type=script&lang=js"
import style0 from "./item-badge.vue?vue&type=style&index=0&id=23fa77e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa77e4",
  null
  
)

export default component.exports